module.exports = __webpack_public_path__ + "img/logo2.17f6a40c.png";